export default (function () {
  return {
    queryStringParams() {
      const params = {};
      const rawParams = window.location.search;
      if (rawParams) {
        rawParams
          .slice(1)
          .split('&')
          .forEach((paramInfo) => {
            const [key, value] = paramInfo.split('=');
            params[key] = value;
          });
      }
      return params;
    },
  };
})();
